<p-fluid>
    <div class="flex flex-col gap-6 max-w-2xl">
        <div class="card flex flex-col gap-6">
            <div class="flex items-center justify-between">
                <div class="font-semibold text-xl">General Info</div>
                @if (dirty()) {
                    <p-button label="Reset" icon="pi pi-undo" severity="secondary" outlined size="small" (click)="resetAll()" />
                }
            </div>

            <div>
                <label class="block font-medium mb-1">Domain</label>
                <input pInputText class="w-full" [value]="realm().Domain" [disabled]="true" />
            </div>

            <div>
                <label class="block font-medium mb-1">Created at</label>
                <div class="text-sm text-muted-color" [pTooltip]="realm().CreatedAt" tooltipPosition="top">
                    {{ createdAtRelative() }}
                </div>
            </div>

            <div>
                <label class="block font-medium mb-1">Category</label>
                <div class="flex items-center gap-2 p-3 border border-surface-200 dark:border-surface-700 rounded">
                    <i class="pi pi-tag text-muted-color"></i>
                    <div class="flex flex-col">
                        <span class="font-medium">{{ category().Name }}</span>
                        <span class="text-xs text-muted-color font-mono">{{ category().type }}</span>
                    </div>
                </div>
                <small class="text-muted-color">— fixed for the realm; managed under Categories</small>
            </div>

            <div>
                <div class="flex items-center justify-between mb-1">
                    <label class="block font-medium">Company</label>
                    @if (canManageCompany()) {
                        <p-button
                            label="Change…"
                            icon="pi pi-arrow-right-arrow-left"
                            severity="secondary"
                            [text]="true"
                            size="small"
                            pTooltip="Reassign this website to a different company"
                            (onClick)="openReassign()"
                        />
                    }
                </div>
                @if (currentCompany(); as c) {
                    <div class="flex items-center gap-2 p-3 border border-surface-200 dark:border-surface-700 rounded">
                        <i class="pi pi-building text-muted-color"></i>
                        <div class="flex flex-col">
                            <span class="font-medium">{{ c.Name }}</span>
                            <span class="text-xs text-muted-color">{{ countryService.getName(c.CountryCode) }} ({{ c.CountryCode }})</span>
                        </div>
                    </div>
                } @else {
                    <div class="flex items-center gap-2 p-3 border border-surface-200 dark:border-surface-700 rounded">
                        <i class="pi pi-question-circle text-muted-color"></i>
                        <span class="text-sm text-muted-color font-mono">{{ realm().CompanyId }}</span>
                    </div>
                }
            </div>

            @if (currentCompany(); as c) {
                <div>
                    <label class="block font-medium mb-1">Country</label>
                    <div class="flex items-center gap-2 text-sm">
                        <span [class]="'flag flag-' + c.CountryCode.toLowerCase()" style="width: 18px; height: 12px"></span>
                        <span>{{ countryService.getName(c.CountryCode) }}</span>
                        <span class="text-xs text-muted-color font-mono">({{ c.CountryCode }})</span>
                    </div>
                    <small class="text-muted-color">— derived from Company; change via Company edit</small>
                </div>
            }

            <div>
                <label class="block font-medium mb-1">Support Email</label>
                <p-inputgroup>
                    <input
                        pInputText
                        class="w-full"
                        [ngModel]="draft().SupportEmail"
                        (ngModelChange)="setSupportEmail($event ?? '')"
                    />
                    @if (draft().SupportEmail !== realm().Support.SupportEmail) {
                        <p-inputgroup-addon>
                            <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setSupportEmail(realm().Support.SupportEmail)" />
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
            </div>

            <div class="text-xs text-muted-color font-mono pt-2 border-t border-surface-200 dark:border-surface-700">
                Realm ID: {{ realm().RealmId }}
            </div>
        </div>
    </div>
</p-fluid>

<app-reassign-company-dialog
    [(visible)]="reassignDialogVisible"
    [realm]="realm()"
    (reassigned)="onReassigned($event)"
/>
